import { useLayoutEffect, useRef, useState } from "react";

export const useJumpToLastVisibleStep = ({
  enabled = false,
  ready = false,
  steps = [],
  setValue,
}) => {
  const jumpedRef = useRef(false);
  const [hasJumped, setHasJumped] = useState(!enabled);

  useLayoutEffect(() => {
    if (!enabled) {
      jumpedRef.current = false;
      return;
    }
    if (!ready || jumpedRef.current || !steps?.length) return;
    jumpedRef.current = true;
    setValue("step", steps.length - 1);
    setHasJumped(true);
  }, [enabled, ready, steps, setValue]);

  return { hasJumped };
};
